import type { FilmMetadata } from "../types/media";

export const hasPublicRating = (value: unknown) => {
  const rating = Number(value);
  return Number.isFinite(rating) && rating > 0;
};

export const formatPublicRating = (value: unknown) =>
  hasPublicRating(value) ? Number(value).toFixed(1) : "не оценено";

const PUBLIC_RATING_KEYS = [
  "vote_average",
  "voteAverage",
  "filmVoteAverage",
  "tmdbRating",
  "rate"
] as const;

export const getPublicRatingValue = (source: (FilmMetadata & { tmdbRating?: number }) | null = {}) => {
  for (const key of PUBLIC_RATING_KEYS) {
    const value = source?.[key];
    if (hasPublicRating(value)) return Number(value);
  }

  return null;
};
